var map = {
	"./anos_60.md": 167,
	"./anos_70.md": 168,
	"./camino_hacia_la_vuelta_de_la_democracia.md": 169,
	"./comienzo_de_una_nueva_era.md": 170,
	"./decada_menemista_y_el_neoliberalismo.md": 171,
	"./decadencia_del_neoliberalismo.md": 172,
	"./el_inicio.md": 173,
	"./final.md": 174,
	"./perdidas_lucha_resistencia.md": 175,
	"./primera_dictadura.md": 176,
	"./tiempos_de_juventud.md": 177
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 166;